import styled from "styled-components";

export const Content = styled.div`
  display: grid;
  gap: 40px;
`;

export const Wrapper = styled.div`
  white-space: nowrap;
`;

export const LoadingContainer = styled.div`
  width: 416px;
  height: 233px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorContainer = styled.div`
  width: 416px;
  height: 233px;
  display: flex;
  align-items: end;
  & > *:first-child {
    width: 100%;
  }
`;
